import { Calendar } from "@fullcalendar/core"
import interaction from "@fullcalendar/interaction"
import dayGrid from "@fullcalendar/daygrid"
import timeGrid from "@fullcalendar/timegrid"
import bootstrap from "@fullcalendar/bootstrap"

import { createNewRequest } from "./new-request"

const calendarDefaults = {
  themeSystem: "bootstrap",
  displayEventEnd: true,
  eventDisplay: "block",
  eventTimeFormat: {
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
    meridiem: "narrow",
    omitZeroMinute: true
  },
  viewDidMount: function() { // Fix buttons for fontawesome
    document.querySelectorAll("span.fa").forEach(el => {
      el.classList.remove("fa")

      const i = document.createElement("i")
      i.className = `fas ${el.className}`
      el.replaceWith(i)
    })
  }
}

const createMainCalendar = function() {
  const el = document.getElementById("calendar")
  if (!el) return

  const calendar = new Calendar(el, $.extend({}, calendarDefaults, {
    plugins: [bootstrap, interaction, dayGrid, timeGrid],
    events: "/requests/calendar.json",
    headerToolbar: {
      left: "prev,next today",
      center: "title",
      right: "dayGridMonth,timeGridWeek,timeGridDay"
    },
    initialView: "dayGridMonth",
    initialDate: el.getAttribute("data-goto"),
    dayMaxEventRows: {
      month: 5
    },
    eventClassNames: function(info) {
      const vehicle = parseInt($('input[name="vehicle"]:checked').val())
      if (!isNaN(vehicle) && vehicle != info.event.extendedProps.vehicle)
        return ["d-none"]
    },
    eventDidMount: function(info) {
      info.el.setAttribute("data-turbo-frame", "modal-frame")
    },
    dateClick: function(info) {
      window.location.href = `/requests/new?date=${info.dateStr}`
    }
  }))

  calendar.render()
  return calendar
}

const createNewCalendar = function() {
  const el = document.getElementById("calendar-new")
  if (!el) return
  const request = createNewRequest()

  const calendar = new Calendar(el, $.extend({}, calendarDefaults, {
    plugins: [bootstrap, timeGrid],
    eventSources: [
      `/requests/calendar.json?exclude=${request.id}`,
      [request]
    ],
    initialDate: request.start,
    headerToolbar: {
      left: "title",
      right: "prev,next today"
    },
    initialView: "timeGridDay",
    height: "auto",
    eventDidMount: function(info) {
      info.el.setAttribute("data-turbo-frame", "modal-frame")
    }
  }))

  calendar.render()
  return calendar
}

export { createMainCalendar, createNewCalendar }
